var render, staticRenderFns
import script from "./CRUDGenerico.vue?vue&type=script&lang=js&"
export * from "./CRUDGenerico.vue?vue&type=script&lang=js&"
import style0 from "./CRUDGenerico.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/shared-components/generico/CRUDGenerico.vue
// module id = 23
// module chunks = 28